import type { IPoint } from '@pressreader/geometry';
import { Align, IContextMenuPosition } from '@pressreader/popups-types';

export function getMenuPositionFromPoint(point?: IPoint): IContextMenuPosition {
    return point
        ? {
              center: point,
              align: {
                  y: Align.Center,
                  x: Align.Center,
              },
          }
        : { center: { x: 0, y: 0 }, align: { y: Align.ScreenCenter, x: Align.ScreenCenter } };
}
